import { api } from '@/shared/api/http'
import type { ApprovalTrail, InboxEntry, WorkflowStatusResponse } from './types'

/**
 * The workflow calls.
 *
 * Note what is absent: no call sends a level number. The server reads the
 * active step from the database, so a tab left open since this morning cannot
 * decide a level that has already moved on, and nothing the client sends can
 * skip one.
 */

export const approvalKeys = {
  inbox: ['approvals', 'inbox'] as const,
  trail: (docId: number | string) => ['approvals', 'trail', String(docId)] as const,
}

export function fetchInbox() {
  return api.get<InboxEntry[]>('/proformas/inbox')
}

export function fetchTrail(docId: number | string) {
  return api.get<ApprovalTrail[]>(`/proformas/${docId}/approvals`)
}

export function submitProforma(docId: number, note?: string) {
  return api.post<WorkflowStatusResponse>(`/proformas/${docId}/submit`, { note: note ?? null })
}

export function approveProforma(docId: number, note?: string) {
  return api.post<WorkflowStatusResponse>(`/proformas/${docId}/approve`, { note: note ?? null })
}

/** The note is mandatory server-side: a return with no reason gives the drafter nothing to act on. */
export function returnProforma(docId: number, note: string) {
  return api.post<WorkflowStatusResponse>(`/proformas/${docId}/return`, { note })
}

export function rejectProforma(docId: number, note: string) {
  return api.post<WorkflowStatusResponse>(`/proformas/${docId}/reject`, { note })
}

export function cancelProforma(docId: number, note: string) {
  return api.post<WorkflowStatusResponse>(`/proformas/${docId}/cancel`, { note })
}
